module.exports = __webpack_public_path__ + "static/media/weatherReport.44e830cf.png";